export default "__VITE_ASSET__iklt6JgG__"